const EventEmitter = require('eventemitter3');

const MoveEvent = require('../../events/MoveEvent');
const { logError } = require('../../logger');

const Leap = function (battleState) {
  this.handle = 'leap';
  this.physical = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim.tile && victim.occupied === false;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim) {
      return;
    }

    try {
      const moveEvent = new MoveEvent(battleState, actor.uid);
      moveEvent.execute(victim);
      moveEvent.actorId = actor.uid;
      moveEvent.victimId = victim.uid;

      // result
      var result = { success: true, moveEvent };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim ? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Leap',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = Leap;
